import { from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { gqlQuery } from "libs/awsLib";
import { mutationInsertStatistics } from "gql/index";
import { TRACK_USER } from '../../actions/trackUser';


const userTrackingEpic = (action$) =>
  action$.pipe(
    ofType(TRACK_USER),
    mergeMap(({ payload }) => 
      from(
        gqlQuery(mutationInsertStatistics, payload) 
      ).pipe(
        map(response => {
          console.log('track agregado', payload);
          return { type: 'TRACK_USER_SUCCESS', payload: response }; 
        }),
        catchError(error => {
          console.error('track error', error);
          return of({ type: 'TRACK_USER_ERROR', payload: error });
        })
      )
    )
  );

export default userTrackingEpic;

